import {signOut} from 'aws-amplify/auth';

import {config} from '../config/amplify/auth';

// FNP-1685: sign out through the auth broker's /logout to this stage's
// redirectSignOut (the portal). Naming the URL explicitly is what stops Amplify
// throwing InvalidOriginException for a cross-origin logout target.
//
// On success Amplify has already set window.location to /logout, so do NOT
// navigate again here: a second assignment would replace that redirect.
// Only a rejection (tokens are cleared first either way) falls back to '/'.
export const signOutViaBroker = async () => {
    const redirectUrl = config?.Cognito.loginWith?.oauth?.redirectSignOut[0];
    try {
        // global: false is signOut()'s own default; the typed input requires it.
        await signOut({global: false, oauth: {redirectUrl}});
    } catch (error) {
        console.error('Sign out did not complete cleanly', error);
        window.location.href = '/';
    }
};
